import Vue from "vue";

Vue.component('ihk-header', {
  data: () => {
    return {
      showNav: false,
      showSearch: false,
    }
  },

  methods: {
    toggleNav() {
      this.showNav = !this.showNav;
    },

    toggleSearch() {
      this.showSearch = !this.showSearch;
    },
  }
});
